import React from 'react'; 
import {BrowserRouter,  Routes, Route } from "react-router-dom" 
import Login from "./login";
import Inicio from './inicio';
import Error from './Error';
import PoolReferencias from './Pool_Documentos/poolreferencias';
import Calcular_Almacenaje from './calcular_almacenaje/calcular_almacenaje';
import PoolResumen from './pool_resumen/pool_resumen';
import Tabla from './Tabla';
const Rutas = () => {
    return(
        <BrowserRouter>
            <Routes>
                <Route exact path='/' element={ <Login />} />  {/* Ruta de LOGIN*/}
                <Route exact path='/login' element={ <Login />} />  {/* Ruta de LOGIN*/}
                <Route exact path='/home' element={ <Inicio />} />  {/* Ruta de LOGIN*/} 
                <Route exact path='/reference-pool' element={ <PoolReferencias />} />  {/* Ruta de LOGIN*/} 
                <Route exact path='/resumen' element={ <PoolResumen />} />  {/* Ruta de LOGIN*/}
                <Route exact path='/calc-storage' element={ <Calcular_Almacenaje />} />  {/* Ruta de Calcular*/}
                <Route path='*' element={ <Error />} />  {/* Ruta de error EN CASO DE QUE LA URL NO EXISTE*/}
            </Routes>  
        </BrowserRouter>
    )
}

export default Rutas;